<template>
  <div class="crud_form_wrapper app_settings_class">
    <div class="table_title_wrapper">
      <div class="title_text_wrapper">
        <h5 style="color: var(--main_theme_clr)" class="font-weight-bold">
          {{ $t("PLACEHOLDERS.statistics") }}
        </h5>
      </div>
      <div class="col-12 text-end">
        <v-btn @click="$router.go(-1)" style="color: var(--main_theme_clr)">
          <i class="fas fa-backward"></i>
        </v-btn>
      </div>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.offices')"
            v-model.trim="data.offices"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clients')"
            v-model.trim="data.clients"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.experience')"
            v-model.trim="data.experience"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.cities')"
            v-model.trim="data.cities"
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatisticsSettings",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        offices: null,
        clients: null,
        experience: null,
        cities: null,
      },
    };
  },

  methods: {
    async getDataToEdit() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "settings?key=statistics",
        });

        this.data.offices = res.data.data[0]?.value?.offices;
        this.data.clients = res.data.data[0]?.value?.clients;
        this.data.experience = res.data.data[0]?.value?.experience;
        this.data.cities = res.data.data[0]?.value?.cities;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },

    async submitForm() {
      this.isWaitingRequest = true;

      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("key", "statistics");

      if (this.data.offices) {
        REQUEST_DATA.append("value[offices]", this.data.offices);
      }
      if (this.data.clients) {
        REQUEST_DATA.append("value[clients]", this.data.clients);
      }
      if (this.data.experience) {
        REQUEST_DATA.append("value[experience]", this.data.experience);
      }
      if (this.data.cities) {
        REQUEST_DATA.append("value[cities]", this.data.cities);
      }

      try {
        await this.$axios({
          method: "POST",
          url: "settings?key=statistics",
          data: REQUEST_DATA,
        });

        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response?.data?.message || error.message);
      }
    },

    validateFormInputs() {
      this.submitForm();
    },
  },

  created() {
    this.getDataToEdit();
  },
};
</script>
